import { ComponentWithLoadingFallback } from "@faire/retailer-visitor-shared/components/GhostLoading/ComponentWithLoadingFallback";
import { GhostBlock } from "@faire/retailer-visitor-shared/components/GhostLoading/GhostBlock";
import { BrandSearchContext } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageBrandSearch/BrandSearch/BrandSearchContext";
import { Button } from "@faire/web--source/slate/Button";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { useContext } from "react";
import { styled } from "styled-components";

export const ToBrandButton: React.FC<{
  ctaText?: string;
  isLoading: boolean;
}> = ({ ctaText, isLoading }) => {
  const { handleBrandClick, brandPagePath } = useContext(BrandSearchContext);

  return (
    <ComponentWithLoadingFallback
      fallback={
        <GhostBlock $width={getSpacing(160)} $height={getSpacing("6x")} />
      }
      isLoading={isLoading}
    >
      <StyledButton
        linkTo={brandPagePath}
        onClick={handleBrandClick("shopBrand")}
      >
        {ctaText ?? (
          <StrictLocalMsg
            defaultMessage="Shop Brand"
            description={{ text: "Link to shop from the brand" }}
          />
        )}
      </StyledButton>
    </ComponentWithLoadingFallback>
  );
};

const StyledButton = styled(Button)`
  width: fit-content;
  min-width: ${getSpacing(160)};
  ${responsiveMediaQueries.mobile} {
    width: 100%;
  }
`;
